import React from "react";
import { Typography } from "@mui/material";
import formatDate from "./formatDate";
import formatCurrency from "./formatCurrency";
import formatPercentage from "./formatPercentage";
import formatInt from "./formatInt";
import Spacer from "./Spacer";
import { hmLightTheme } from "../themes/hmTheme";

const LabelField = ({ ...props }) => {
  const { title, value, format } = props;
  let formattedValue = value;
  let fontFamily = hmLightTheme?.palette?.textFontFamily;
  let valueFontFamily = hmLightTheme?.palette?.textFontFamily;
  const titlePosition = props.titlePosition
    ? props.titlePosition
    : "left"; /* left, top */
  valueFontFamily =
    props.fontFamily == "numberFontFamily"
      ? hmLightTheme?.palette?.numberFontFamily
      : hmLightTheme?.palette?.textFontFamily;

  // console.log("--0000------", hmLightTheme?.palette?.numberFontFamily);
  if (formattedValue == "N/A" || formattedValue == "NA") {
    return (
      <Typography variant="body2" color="black" gutterBottom>
        <label
          style={{
            width: "200px",
            display: "block",
            fontWeight: "bold",
            // float: "left",
            float: titlePosition == "left" ? "left" : "none",
          }}
        >
          {title ? `${title}: ` : ""}
        </label>
        {formattedValue}
      </Typography>
    );
  }

  if (
    formattedValue == null ||
    formattedValue == undefined ||
    formattedValue == "" ||
    formattedValue == "undefined" ||
    formattedValue == "null" ||
    formattedValue == "NaN" ||
    formattedValue == "0000-00-00 00:00:00"
  ) {
    return (
      <Typography variant="body2" color="black" gutterBottom>
        <label
          style={{
            width: "200px",
            display: "block",
            fontWeight: "bold",
            // float: "left",
            float: titlePosition == "left" ? "left" : "none",
          }}
        >
          {title ? `${title}: ` : ""}
        </label>
        &nbsp;&nbsp;
      </Typography>
    );
  }

  if (false && format == "date") {
    formattedValue = formatDate(value);
    valueFontFamily = hmLightTheme?.palette?.numberFontFamily;
  } else if (
    format == "currency" ||
    format == "money" ||
    format == "price" ||
    format == "amount" ||
    format == "$"
  ) {
    formattedValue = formatCurrency(value);
    valueFontFamily = hmLightTheme?.palette?.numberFontFamily;
  } else if (
    format == "percentage" ||
    format == "percent" ||
    format == "rate" ||
    format == "%"
  ) {
    formattedValue = formatPercentage(value);
    valueFontFamily = hmLightTheme?.palette?.numberFontFamily;
  } else if (format == "int" || format == "integer") {
    formattedValue = formatInt(value);
    valueFontFamily = hmLightTheme?.palette?.numberFontFamily;
  } else if (format == "richtext") {
    formattedValue = value.replace(/\n/g, "<br/>");
  }

  if (format == "richtext") {
    return (
      <Typography variant="body2" color="black" gutterBottom>
        <label
          style={{
            width: "200px",
            display: "block",
            fontWeight: "bold",
            // float: "left",
            float: titlePosition == "left" ? "left" : "none",
          }}
        >
          {title ? `${title}: ` : ""}
        </label>
        <span
          dangerouslySetInnerHTML={{ __html: formattedValue }}
          style={{
            display: "block",
            marginLeft: titlePosition == "left" ? "200px" : "0px",
          }}
        />
      </Typography>
    );
  } else {
    return (
      <Typography variant="body2" color="black" gutterBottom>
        <label
          style={{
            width: "200px",
            display: "block",
            fontWeight: "bold",
            // float: "left",
            float: titlePosition == "left" ? "left" : "none",
            fontFamily: fontFamily as unknown as string,
          }}
        >
          {title ? `${title}: ` : ""}
        </label>
        <span
          style={{
            fontFamily:
              typeof valueFontFamily === "string"
                ? valueFontFamily
                : "Proxima Nova",
          }}
        >
          {formattedValue}
          {props?.prefix ? " " + props.prefix : ""}
        </span>
        {title == "Term" ? " Month(s)" : ""}
      </Typography>
    );
  }
};
export default LabelField;
